import classNames from 'classnames'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {LayoutContext} from '../layouts/Default/LayoutContext'
import './FeedCard.css'
import {BsFire} from "react-icons/bs";
import {Link} from "react-router-dom";
import {staticPaths} from "../../routes/staticPaths";
import {PrayersIntentionSvg} from "../Svgs/PrayersSvg";

export const PrayerCard = ({prayer_category_code, prayer_category, prayer_title, className = "", children}) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)


    let borderColor, textColor, bgColor;
    switch (prayer_category_code) {
        case 'petition':
        case 'intercession':
        case 'protection':
        case 'healing':
        case 'deliverance':
        case 'strength':
        case 'guidance':
            bgColor = 'bg-gradient-blue'
            borderColor = 'border-blue-500'
            textColor = 'bg-blue-50 text-blue-700'
            break;
        case 'thanksgiving':
        case 'gratitude':
        case 'praise':
            bgColor = 'bg-gradient-orange'
            borderColor = 'border-orange-400'
            textColor = 'bg-orange-50 text-orange-500'
            break;
        case 'love':
        case 'faith':
        case 'hope':
        case 'trust':
        case 'wisdom':
            bgColor = 'bg-gradient-primary'
            borderColor = 'border-red-500'
            textColor = 'bg-primary-50 text-primary'
            break;
        case 'conversion':
        case 'repentance':
        case 'mercy':
            bgColor = 'bg-gradient-indigo'
            borderColor = 'border-indigo-500'
            textColor = 'bg-indigo-50 text-indigo-600'
            break;
        case 'family':
        case 'unity':
        case 'vocation':
            bgColor = 'bg-gradient-green'
            borderColor = 'border-green-500'
            textColor = 'bg-green-50 text-green-600'
            break;
        case 'remembrance':
            bgColor = 'bg-gradient-indigo-light'
            borderColor = 'border-indigo-500'
            textColor = 'bg-indigo-50 text-indigo-600'
            break;
        case 'peace':
            bgColor = 'bg-gradient-teal'
            borderColor = 'border-teal-500'
            textColor = 'bg-teal-50 text-teal-600'
            break;
        case 'praying_with_the_pope':
            bgColor = 'bg-gradient-green'
            borderColor = 'border-green-500'
            textColor = 'bg-green-50 text-green-700'
            break;
        default:
            bgColor = 'bg-gray-500'
            borderColor = 'border-gray-500'
            textColor = 'bg-gray-50 text-gray-500'
    }

    return (
        <div
            className={classNames(
                "m-3 p-3 min-h-40 flex flex-col shadow-block rounded-xl tracking-wide overflow-hidden relative",
                borderColor, bgColor, className
            )}>
            <PrayersIntentionSvg
                size={140} style={{background: 'unset', bottom: -15, left: -10, zIndex: 0}}
                className={classNames('absolute opacity-30', textColor)}
            />
            <div className="mb-2 flex justify-end">
                <Link className="no-underline" to={{
                    pathname: staticPaths.prayers.pathname,
                    search: "?prayer-code=" + prayer_category_code,
                }}>
                    <span
                        style={{padding: '3px 10px', borderRadius: 999}}
                        className={classNames(
                            "w-fit flex flex-center font-semibold text-sm tracking-wider",
                            textColor,
                        )}>
                        <BsFire size={14} className="mr-1"/>
                        {prayer_category}
                    </span>
                </Link>
            </div>

            <div className="flex flex-col flex-1 gap-3">
                {prayer_title && (
                    <p className="font-bold text-xl tracking-wide leading-tight flex flex-center text-white-70">
                        {prayer_title}
                    </p>
                )}
                <div
                    className="my-auto space-x-1 text-center font-semibold text-base text-white italic content-prayer z-3">
                    {children}
                </div>
            </div>
            <div style={{height: 28}}/>
        </div>
    )
}

